import React from "react";
import { Route } from "react-router-dom";
import RequireAuth from "../components/VersatileComponents/RequireAuth";
import SubAdminBranches from "../pages/Collection/SubAdminBranches";

const subAdminRoutesData = [
  { path: "/subAdminbranch", component: SubAdminBranches },
];

const SubAdminRoutes = () => {
  return (
    <>
      {subAdminRoutesData.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            <RequireAuth>
              <route.component />
            </RequireAuth>
          }
        />
      ))}
    </>
  );
};

export default SubAdminRoutes;
